import React from 'react';

interface LoadingProps {
  isLoading: boolean;
  message?: string;
}

const Loading: React.FC<LoadingProps> = ({ isLoading, message = "Loading..." }) => {
  if (!isLoading) return null;

  return (
    <div className="w-full min-h-screen bg-[#1a1e23] flex items-center justify-center">
      <div className="text-center">
        {/* Bouncing Loader */}
        <div className="relative mb-4">
          <img
            src="/WEB-LOADER.png"
            alt="Loading"
            className="w-12 h-12 mx-auto loading-bounce"
            style={{
              animation: 'bounce 1s ease-in-out infinite',
              transformOrigin: 'center',
              willChange: 'transform'
            }}
          />
        </div>
        
        {/* Loading Message */}
        <p className="text-[#f4f2e5] font-medium text-sm opacity-80">{message}</p>
        
      </div>
    </div>
  );
};

export default Loading;
